import React from "react";
import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import LanguageIcon from "@material-ui/icons/Language";
import LinkedInIcon from "@material-ui/icons/LinkedIn";
import PublicIcon from "@material-ui/icons/Public";
import RssFeedIcon from "@material-ui/icons/RssFeed";
import YouTubeIcon from "@material-ui/icons/YouTube";
import { SocialNetwork } from "../../service/data";
import BlueskyIconSVG from "./BlueskyIconSVG";
import ThreadsIconSVG from "./ThreadsIconSVG";
import TikTokIconSVG from "./TikTokIconSVG";
import XIconSVG from "./XIconSVG";

/**
 * A network's mark: the badge on a card, and the button on a contributor's page. An unknown network
 * used to throw, which took the whole card down with it - a network the API knows about and the
 * client does not is a missing icon, not a broken page.
 */
const getSocialIcon = (source: SocialNetwork) => {
    switch (source) {
        case "bluesky":
            return (<BlueskyIconSVG />);
        case "facebook":
            return (<FacebookIcon />);
        case "instagram":
            return (<InstagramIcon />);
        case "linkedin":
            return (<LinkedInIcon />);
        case "rss":
            return (<RssFeedIcon />);
        case "threads":
            return (<ThreadsIconSVG />);
        case "tiktok":
            return (<TikTokIconSVG />);
        case "twitter":
            return (<XIconSVG />);
        case "website":
            return (<LanguageIcon />);
        case "youtube":
            return (<YouTubeIcon />);
    }

    return (<PublicIcon />);
};

export {
    getSocialIcon,
}
